import styled from 'styled-components'

export const StyledNewsAlertActions = styled.div`
  display: flex;
`
